/**
 * Shared utilities for hazard components.
 * Consolidates duplicated helpers across Hazard, ActivityHazardMarkers, and HazardModal.
 */

export const parseMetadata = (metadata) => {
  if (!metadata) return {};
  if (typeof metadata === 'object') return metadata;
  try {
    return JSON.parse(metadata);
  } catch (error) {
    return {};
  }
};

export const toNumber = (value) => {
  if (value === undefined || value === null || value === '') return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

/**
 * Safely remove a Leaflet layer from a FeatureGroup ref.
 * Swallows errors when the layer or map is already torn down.
 */
export const safeRemoveLayer = (featureGroupRef, layer) => {
  if (!layer || !featureGroupRef?.leafletElement) return;
  try {
    featureGroupRef.leafletElement.removeLayer(layer);
  } catch (e) {
    console.warn('Could not remove layer (may already be removed):', e.message);
  }
};

/** Shared hazard zone circle style for PropertyMap overlay circles. */
export const HAZARD_ZONE_STYLE = {
  color: '#f5222d',
  fillColor: '#f5222d',
  fillOpacity: 0.15,
  weight: 2,
  dashArray: '5,5',
};

/** Shared hazard area shape style (severity-colored). */
export const HAZARD_AREA_STYLE = {
  fillOpacity: 0.3,
  weight: 2,
};
